import { render, staticRenderFns } from "./AddDPEnviroment.vue?vue&type=template&id=b00c4c80&scoped=true&"
import script from "./AddDPEnviroment.vue?vue&type=script&lang=js&"
export * from "./AddDPEnviroment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00c4c80",
  null
  
)

export default component.exports